module.exports = __webpack_public_path__ + "../resources/img/ic_unlinked_default.9db8b2bb.svg";